import styled, { css, keyframes } from "styled-components"
import { colors } from "../../lib/colors"

export const LoadingContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100vh;
  p {
    opacity: 0;
    color: black;
    font-family: "SemiBold";
  }
  span {
    opacity: 0;
    color: black;
    font-family: "Regular";
  }
  .company-logo {
    margin-bottom: 34px;
  }
  .game-logo {
    width: 100%;
    height: 100%;
  }
  @media (min-width: 768px) {
    .company-logo {
      width: 82px;
      height: 34px;
      margin-bottom: 34px;
    }
  }

  @media (min-width: 1024px) {
    .company-logo {
      margin-bottom: 53px;
    }
  }
`

export const ProgressBarContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const ProgressBarBar = styled.div`
  margin-top: 24px;
  width: 164px;
  border-radius: 100px;
  height: 7.5px;
  background-color: ${colors.progressBarBackground};
  position: relative;

  @media (min-width: 768px) {
    width: 196px;
    height: 8px;
    margin-top: 30px;
  }

  @media (min-width: 1024px) {
    width: 278px;
    margin-top: 35px;
  }
`

export const ProgressBarMoving = styled.div<{
  progress: number
  loaderIsFinished: boolean
}>`
  border-radius: 100px;
  height: 7.5px;
  background-image: ${colors.blueGradient};
  width: ${({ progress }) => progress / 2 + "%"};
  transition: width 0.1s linear;
  z-index: 2000;
  animation: ${({ loaderIsFinished }) =>
    loaderIsFinished && "fillbar 2s linear forwards"};

  @keyframes fillbar {
    0% {
      width: 50%;
    }
    100% {
      width: 100%;
    }
  }

  @media (min-width: 768px) {
    height: 8px;
  }
`
